// Enable the @carbon/ibm-products components the pricing pages use. Feature flags are a
// global singleton, so importing this module once (from PricingPageLayout, which every
// pricing page renders) turns them on before any pricing component mounts.
//
// EditInPlace/SidePanel are already enabled by components/inline-edit/ibm-products-config;
// this adds the rest the pricing refactor depends on.
import { pkg } from '@carbon/ibm-products';

pkg.component.EmptyState = true;
